<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <mat-slide-toggle
        color="primary"
        class="mb-4"
        [checked]="unreadOnly()"
        (change)="onUnreadOnlyChange($event.checked)">
        {{ 'shared.skeleton.notifications.logsDialog.unreadOnly' | translate }}
    </mat-slide-toggle>
    <p-table
        stripedRows
        [value]="items()"
        [loading]="loading()"
        [paginator]="totalCount() > tableRowDefault"
        [totalRecords]="totalCount()"
        [first]="lastLoadEvent().first ?? 0"
        [multiSortMeta]="defaultSort"
        [rows]="tableRowDefault"
        [rowsPerPageOptions]="tableRowsOptions"
        [paginatorLocale]="(locale$ | async)!"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="tableCurrentPageReportTemplate()"
        [columns]="columns"
        [resizableColumns]="true"
        [lazy]="true"
        (onLazyLoad)="loadItems($event)"
        paginatorDropdownAppendTo="body"
        columnResizeMode="expand"
        sortMode="multiple">
        <ng-template #header>
            <tr class="table-headers">
                @for (col of columns; track col.field) {
                    <th
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="!col.sort"
                        pResizableColumn
                        title="{{ col.label | translate }}"
                        scope="col">
                        <div class="p-table-sort-header">
                            {{ col.label | translate }}
                            @if (col?.sort) {
                                <p-sortIcon
                                    field="{{ col.field }}"
                                    class="flex items-center"></p-sortIcon>
                            }
                        </div>
                    </th>
                }
            </tr>
        </ng-template>
        <ng-template #body let-item>
            <tr
                class="cursor-pointer"
                [class.font-bold]="!item.read"
                (click)="openDetail(item)">
                <td class="w-2/12">
                    {{ item.sentAtUtc | translateDate: 'shortDate' }}
                </td>
                <td class="w-3/12 max-w-xs truncate">
                    @if (!item.read) {
                        <p-tag
                            [value]="
                                'shared.skeleton.notifications.logsTable.new'
                                    | translate
                            "></p-tag>
                    }
                    {{ item.title }}
                </td>
                <td class="w-7/12 max-w-xl truncate">
                    {{ item.body }}
                </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <apcam-primeng-no-records
                class="table-row"
                [colSpan]="columns.length"
                [noLoadedData]="!unreadOnly()" />
        </ng-template>
    </p-table>
</apcam-shared-dialog-shell>
